import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './utils/toastSetup';   // 토스트 위치·중첩 상한·종류별 표시시간
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(<App />);
